let obfs = document.querySelectorAll('.nsl-obl')

obfs.forEach(obf => {
    obf.addEventListener('click', function (e) {
        e.preventDefault();
        let link = atob(this.getAttribute('data-link'));
        window.open(link, '_blank').focus();
    });
})
